import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AdminCreateClient from "./AdminCreateClient";
import ClientList from "./ClientList";
import ProductList from "./ProductList";




export default function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = parseInt(sessionStorage.getItem("dineshAuthExpiry"), 10);
      const now = new Date().getTime();

      if (!expiry || now > expiry) {
        sessionStorage.clear();
        navigate("/Dinesh", { replace: true });
      }
    }, 10000); // check every 10s

    return () => clearInterval(interval);
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/Dinesh", { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 relative">

      <div className="min-h-screen bg-gray-50 px-4 py-6">
        <AdminCreateClient />
        <ClientList />
        <ProductList />
      </div>
      {/* Logout button */}
      <button
        onClick={handleLogout}
        className="
          absolute top-4 right-4
          px-4 py-2
          bg-red-600 text-white text-sm font-medium
          rounded-md shadow-md
          hover:bg-red-700 transition
          focus:outline-none focus:ring-2 focus:ring-red-400
        "
      >
        Logout
      </button>

    </div>
  );
}
